// import { AccountBalanceWalletRounded } from '@mui/icons-material'
import React from 'react'
import newIcon from '../../images/icons/etiquetaNuevo.png'

// const style = {
//     status: {
//         display: 'inline-flex',
//         alignItems: 'center',
//         backgroundColor: '#60DC32',
//         color: 'black',
//         padding: '4px 14px',
//         borderRadius: '9px',
//         fontSize: '.7rem'
//     },
//     dot: {
//         height: '12px',
//         width: '12px',
//         borderRadius: '50%',
//         backgroundColor: '#37C846',
//         display: 'inline-block',
//     },
// }
const style = {
   status: {
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: 'rgba(55,200,70,0.15)',
      color: '#37C846',
      padding: '4px 14px',
      borderRadius: '40px'
   },
   dot: {
      height: '12px',
      width: '12px',
      borderRadius: '50%',
      backgroundColor: '#37C846',
      display: 'inline-block'
   }
}

export default function NewIcon() {
   return (
      // <span style={style.status}>
      //     <span style={style.dot}>

      //     </span>&nbsp;¡NUEVO!
      // </span>
      <>
         <img src={newIcon} alt="" />
      </>
   )
}
